/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { useTranslation } from "next-i18next";

import LinkText from "components/LinkText";

import styles from "./SearchNoResults.module.scss";

const SearchResults = () => {
  const { t } = useTranslation("translations");

  return (
    <section className={styles.noResults}>
      <p className={styles.text}>{t("web_search_no_result_text")}</p>
      <LinkText href={"https://bit.ly/filmønsker"} className={styles.link} bold>
        {t("web_search_add_to_wishlist")}
      </LinkText>
    </section>
  );
};

export default SearchResults;
